'use strict';

const Slide = require('./slide');
const Modal = require('../modal');
const $ = require('jquery');
const lang = require('../lang');
const template = require('../templates/form-slide.hbs');
const SignSlide = require('./sign-slide');
import intlTelInput from 'intl-tel-input';
import Keyboard from 'simple-keyboard';

var selectedInput;
var keyboardInstance;
var isValidating = false;

var phone = null;

module.exports = class extends Slide {
  constructor(context = {}) {
    context = $.extend({}, { title: lang.get('form_title') }, context);
    super(template, context);
    _idletimer = _mainidletimer;
    this._timer = 1;
    this.moduleUniqueIdentifier = context.moduleUniqueIdentifier;
    this.formInstructions = context.formInstructions;
    this.licensePlateRequired = context.licensePlateRequired; // Store the setting

    this.domEvents = {
      'click a[data-nav-next]': '_clickNextValidation',
      'keyup form': '_enterKeyValidation',
      'click form': '_enterKeyValidation',
      'change form': '_enterKeyValidation',
      //'mousemove': '_resetIdleTimer',
      'keydown': '_resetIdleTimer',
      'click': '_resetIdleTimer'
    };
    this.on('beforeEnter', this._nextButtonText);
    this.on('beforeEnter', this._setCustomLabel);
    this.on('afterEnter', this._addExtraInfo);
    this.on('afterEnter', this._focusInput);
    this.on('afterEnter', this._stopIdleTimer);
    this.on('afterEnter', this._countdown);
    this.on('afterEnter', this._initiateAutoPopulate);
    this.on('afterEnter', this._initiateVirtualKeyboard);
    this.on('beforeLeave', this._removeVirtualKeyboard);
    this.on('beforeLeave', this._restoreValidation);
  }

  reset() {
    this.$el.find('form')[0].reset();
  }

  _tryReturnToSignSlide(e) {
    if (this._slideshow.slides[this._slideshow.previousIndex] instanceof SignSlide) {
      clearInterval(_idleintervalHandler);
      _idletimer = _mainidletimer;
      window.location.hash = '/' + this._slideshow.previousIndex;
      e.preventDefault();
      e.stopPropagation();
      return true;
    }
    return false;
  }

  _anyInputIsFocused() {
    return this.$el.find('input:focus').length !== 0;
  }

  // validates form, returns true if validated, false otherwise and displays an error message
  _validation() {
    if (isValidating) return false; // Prevent multiple validations
    isValidating = true; // Set the flag to indicate validation in progress
    const emptyFields = [];
    const fieldregex = [];
    const phoneElement = document.getElementById('label_phone_number');
    if (phoneElement != null && phoneElement.value) {
      phoneElement.value = phoneElement.value.replace(/\s/g, '');
      if(phone && window.intlTelInputUtils) {
        // Always use E164 format for consistency
        phoneElement.value = phone.getNumber(intlTelInputUtils.numberFormat.E164);
      }
    }
    if ($("#label_phone_number").length) {
      localStorage.setItem("phone_no", $("#label_phone_number").val());
    }
    this.$el.find('input[required]').each(function () {
      const $this = $(this);
      const field_type = $(this).attr('type');
      var fieldid = $this.attr('name');

      if (field_type === 'checkbox' || field_type === 'radio') {
        var chckcnt = $("input[name=" + fieldid + "]:checked").length
        if (chckcnt === 0) {
          emptyFields.push($this);
        }
      }

      if ($this.val().length === 0) {
        emptyFields.push($this);
      }

      var fieldwithregex = $(this).attr('data-regex-validation');
      var is_mandatory = false;
      var element = $("#" + fieldid).get(0);
      if (element) {
        is_mandatory = element.hasAttribute('required');
      }

      if (typeof is_mandatory !== 'undefined' && is_mandatory !== false && typeof (fieldwithregex) !== 'undefined' && fieldwithregex != null || (fieldid == 'label_phone_number' && typeof is_mandatory !== 'undefined' && is_mandatory !== false)) {

        fieldregex.push({
          fieldname: fieldid,
          fieldwithregex: fieldwithregex
        });

      }
    });

    if (emptyFields.length !== 0) {
      new Modal({
        titleText: lang.get('form_modal_title'),
        bodyText: lang.get('form_modal_body'),
        submitBtnText: lang.get('form_modal_button'),
        onHidden: () => {
          isValidating = false; // Reset the flag when modal closes
          //emptyFields[0].focus(); // This caused a weird state with virtual keyboard
        }      });
      return false;
    }

    if (this._whoVisitValidator && !this._whoVisitValidator()) {
      new Modal({
        titleText: lang.get('form_required'),
        bodyText: lang.get('select_person_from_list'),
        submitBtnText: lang.get('form_modal_button'),
        onHidden: () => {
          isValidating = false;
          document.getElementById("label_who_visit").focus();
          document.getElementById("label_who_visit").value='';
        }
      });
      return false;
    }

    return fieldregex.every(({ fieldname, fieldwithregex }) => {
      const value = document.getElementById(fieldname).value;
      const isPhoneNumber = fieldname === "label_phone_number";

      if (isPhoneNumber) {

        if (this._slideshow._location.module_sms === 1 && this._slideshow._location.module_verify_otp === 1) {
          $.ajax({
            method: 'POST',
            url: 'slideshow/check-eligibility-for-otp',
            data: { "phone_no": value },
            async: false,
            success: (res) => {
              res = JSON.parse(res);
              if (res.status == "success") {
                // Remove the slide
                this._slideshow.addSmsOtpSlide('remove');
              } else {
                // Add the slide
                this._slideshow.addSmsOtpSlide('add');
              }
            }
          });
        }
      }
      const regex = isPhoneNumber
        ? /^(00|\+)[1-9]{1}([0-9][\s]*){9,16}$/g
        : new RegExp(fieldwithregex);

      let formInstructions = this._slideshow._formInstructions ? this._slideshow._formInstructions : lang.get('form_modal_pattern_not_match');
      // Split the 'value' string into an array of values based on the specified delimiters
      const values = value.split(/[ ,;\/]+/);
      // Iterate over each value in the array
      for (const singleValue of values) {
        // Perform the match operation on the current value
        if (regex && !singleValue.match(regex)) {
          // If the match fails, create and show the modal with the appropriate messages
          const bodyText = isPhoneNumber
            ? lang.get('form_modal_number_body')
            : formInstructions;

          new Modal({
            titleText: lang.get(fieldname),
            bodyText,
            submitBtnText: lang.get('form_modal_button'),
            onHidden: () => isValidating = false // Reset flag when modal closes
          });

          return false;
        }
      }
      isValidating = false;
      return true;
    });
  }

  // DOM EVENTS

  _clickNextValidation(e) {
    clearInterval(_idleintervalHandler);
    _idletimer = _mainidletimer;
    if (!this._validation())
      return false;
    var breathalyzer_check = localStorage.getItem("breathalyzer_check") || 0;
    var main_location_id = localStorage.getItem("main_location_id") || 0;
    const trackId = this._slideshow.getTrackId();
    if (this._slideshow._location.printout_directly_after_form_slide) {
      $.ajax({
        method: 'POST',
        url: 'slideshow/slideshow_watcher_sign',
        data: $.extend({}, this._slideshow.getFormData(), {
          subLocationId: this._slideshow.getSublocationId(),
          trackId: trackId,
          readSlideshow: !this._slideshow.hasSkipped,
          main_location_id: main_location_id,
          breathalyzer_check: breathalyzer_check
        }),
        success: (res) => {
          if (res !== '') {
            $("#form_field_signature_id").val(res);
          } else {
            $("#form_field_signature_id").val('0');
          }
        }
      });
    }
    this._tryReturnToSignSlide(e);
  }

  _enterKeyValidation(e) {
    const fieldName = e.target.name;
    const fieldtype = e.target.type;
    var fieldValue = e.target.value;
    const index = e.target.dataset.key;
    if (fieldtype == 'checkbox') {
      var temp = "";
      $("#" + fieldName + ":checked").each(function () {
        temp += this.value + ",";
      });
      temp = temp.slice(0, -1);
      fieldValue = temp;
    }

    if (index) {
      this._slideshow._setCustomFieldValue(index, fieldValue) // Update a custom field value every key up event
    }
    if (e.which === 13 && this._validation()) {
      if (!this._tryReturnToSignSlide(e))
        this._slideshow.navNext();
    }
  }

  _addExtraInfo() {
    var idscanApproveStatus = localStorage.getItem("idscan_approve_status");
    var idscanID = localStorage.getItem("idscan_id");
    if(idscanApproveStatus === '0') {
      new Modal({
        titleText: lang.get('queue_wait'),
        bodyText: lang.get('idscan_approve_wait'),
      });
      $(".close").hide();
      $("#modal-submit-button").hide();
      $( "body" ).css( "pointer-events", "none" );
      this.getstatusofIdScanApproval(idscanID);
      return false;
    }
    $(".extra_information").empty().append(this._slideshow._getFormInstructionText());
    this._slideshow.setControlQuestion();
  }

  // SLIDE EVENTS

  _nextButtonText() {
    if (this._slideshow.slides[this._slideshow.previousIndex] instanceof SignSlide)
      this.$el.find('.slideshow-btn-next-text').html(lang.get('button_return'));
    else
      this.$el.find('.slideshow-btn-next-text').html(lang.get('button_next'));
  }

  _focusInput() {
    var uniqueidentificationnumber = localStorage.getItem("unique_identification_number");
    if (uniqueidentificationnumber != undefined) {
      $("#form_field_unique_identification").val(uniqueidentificationnumber);
    }
    var regnr = localStorage.getItem("regnr");
    if (regnr != undefined && regnr !== null && regnr !== 'null') {
      $("#form_field_registration_number").val(regnr);
    }
    if (!this._anyInputIsFocused())
      this.$el.find('input[type="text"]').first().focus();
  }

  _resetIdleTimer() {
    $('.idle-timer-container').hide();
    _idletimer = _mainidletimer;
  }

  _countdown() {
    _idletimer = _mainidletimer;
    $('.idle-timer-container').hide();
    const $domTimer = this.$el.find('#idle-timer');
    _idleintervalHandler = setInterval(() => {
      _idletimer -= 1;
      if (_idletimer <= 30) {
        $('.idle-timer-container').show();
        $domTimer.html(_idletimer);
      }
      if (_idletimer === 0) {
        this._slideshow._clearForm();
        $('#modal').modal('hide');
        clearInterval(_idleintervalHandler);
        _idletimer = _mainidletimer;
        $('.idle-timer-container').hide();
        window.location.hash = '/';
      }
    }, 1000);
  }

  _stopIdleTimer() {
    if (_idleintervalHandler !== undefined) {
      clearInterval(_idleintervalHandler);
    }
  }

  _setCustomLabel() {
    // if ($("#label_exist_code").val() === '0') {
      var labelData = this._slideshow._setFormLabel();
      var uniqueidentificationlabel = localStorage.getItem("unique_identification_label");
      var uniqueidentificationnumber = localStorage.getItem("unique_identification_number");
      var custom_signature_valueCoded = localStorage.getItem("custom_signature_value");
      let moduleUniqueIdentifier = this.moduleUniqueIdentifier;

      let custom_signature_valueDecoded = decodeURIComponent(custom_signature_valueCoded);

      var custom_signature_value;
      if (custom_signature_valueDecoded.startsWith('"') && custom_signature_valueDecoded.endsWith('"')) {
        custom_signature_value = JSON.parse(custom_signature_valueDecoded.substring(1, custom_signature_valueDecoded.length - 1));
      } else {
        custom_signature_value = JSON.parse(custom_signature_valueDecoded);
      }

      if (labelData.length > 0) {
        $("#form_labels").html('');
        var labelFormData = '';
        var checkUniqueIdentifier = 0;
        for (let i = 0; i < labelData.length; i++) {

          if (custom_signature_value != '' && custom_signature_value != undefined) {
            $.each(custom_signature_value, function(k,v){
                if (v['label']['name'] ==labelData[i].name) {
                  labelData[i].value = v['value'];
                }
            })
          }

          if (uniqueidentificationlabel === labelData[i].name) {
            labelData[i].value = uniqueidentificationnumber;
          }

          var req = '';
          if (labelData[i].required === 1) {
            req = 'required';
          }
          var cls = 'input-flat';
          if (labelData[i].field_type != null && labelData[i].field_type != 'textbox' && labelData[i].field_type != 'autocomplete') {
            cls = 'fieldcls';
          }


          labelFormData = labelFormData + '<div style="padding-left:10px;padding-right:10px" class="form-group ' + cls + '"><label><img class="label-icon" src="' + labelData[i].icon + '">' + lang.get(labelData[i].name);
          if (labelData[i].required === 1) {
            labelFormData = labelFormData + '*';
          }
          labelFormData = labelFormData + '</label>';

          if (labelData[i].field_type == 'radio') {
            var radiohtml = '<fieldset><div>';
            if (labelData[i].field_value != '') {
              $.each(labelData[i].field_value, function (kk, vv) {
                var rdiochck = '';
                if (labelData[i].value != undefined && labelData[i].value == vv) {
                  rdiochck = 'checked';
                }
                radiohtml += '<input ' + req + ' ' + rdiochck + ' type="radio" data-key="' + i + '" id="' + vv + '" name="' + labelData[i].name + '" value=' + vv + ' style="width:20px;height:20px;position:relative;bottom:-4px;">';
                radiohtml += '<label for="' + vv +'" style="padding-left: 5px; margin-right: 5px;">' + vv + '</label>&nbsp;&nbsp;';
              })
            }
            radiohtml += '</div></fieldset>';
            labelFormData = labelFormData + radiohtml;
          } else if (labelData[i].field_type == 'checkbox') {
            var checkboxhtml = '<fieldset><div>';
            if (labelData[i].field_value != '') {
              $.each(labelData[i].field_value, function (kk, vv) {
                var chck = '';

                if (labelData[i].value != '' && labelData[i].value != undefined) {
                  var arr = labelData[i].value;
                  arr.split(",");
                  if (arr.indexOf(vv) != -1) {
                    chck = 'checked';
                  }
                }

                checkboxhtml += '<input ' + req + ' ' + chck + ' data-key="' + i + '" type="checkbox" id="' + labelData[i].name + '" name="' + labelData[i].name + '" value=' + vv + ' style="width:auto">';
                checkboxhtml += '<label for="' + vv + '">' + vv + '</label>&nbsp;&nbsp;';
              })
            }
            checkboxhtml += '</div></fieldset>';
            labelFormData = labelFormData + checkboxhtml;
          } else if (labelData[i].field_type == 'autocomplete') {
            var autoval = '';
            if (labelData[i].value != undefined && labelData[i].value != '') {
              autoval = labelData[i].value;
            }
            labelFormData = labelFormData += '<div class="" style="width:100%;"><input ' + req + ' id="' + labelData[i].name + '" data-key="' + i + '" data-autoarr="' + labelData[i].field_value + '" value="' + autoval + '" class="autocmp form-control" type="text" name="' + labelData[i].name + '"></div>';
          } else {
            var labeltype = 'type="text"';
            if (labelData[i].name == 'label_phone_number') {
              labeltype = 'type="tel"';
            }
            labelFormData = labelFormData + '<input class="form-control" ' + labeltype + ' ' + req + ' name="' + labelData[i].name + '" data-key="' + i + '" value="' + (labelData[i].value || "") + '" id="' + labelData[i].name + '"';
            if (labelData[i].regex_validation != null && labelData[i].regex_validation != "") {
              const reg_pattern = labelData[i].regex_validation;
              labelFormData = labelFormData + 'data-regex-validation="' + reg_pattern + '" ';
            }
            if (labelData[i].name === uniqueidentificationlabel) {
              labelFormData = labelFormData + " value='";
              if (uniqueidentificationnumber !== undefined) {
                labelFormData = labelFormData + uniqueidentificationnumber;
              }
              labelFormData = labelFormData + "'";
              checkUniqueIdentifier = 1;
            }
            labelFormData = labelFormData + 'autocomplete="off" aria-autocomplete="none">';
          }
          labelFormData = labelFormData + '</div>';
        }
        if (checkUniqueIdentifier) {
          labelFormData = labelFormData + '<input type="hidden" name="unique_identification_number" id="form_field_unique_identification" class="form-control" value="' + uniqueidentificationnumber + '">';
        } else {
          if (moduleUniqueIdentifier && uniqueidentificationlabel !== 'form_field_registration_number') {
            labelFormData = labelFormData + '<div class="form-group input-flat"><label>' + lang.get(uniqueidentificationlabel) + '</label><input type="text" name="unique_identification_number" id="form_field_unique_identification" class="form-control" value="';
            if (uniqueidentificationnumber !== undefined) {
              labelFormData = labelFormData + uniqueidentificationnumber;
            }
            labelFormData = labelFormData + '" readonly></div>';
          } else {
            labelFormData = labelFormData + '<input type="hidden" name="unique_identification_number" id="form_field_unique_identification" class="form-control" value="">';
          }
        }


        $("#form_labels").html(labelFormData);
        $("#label_exist_code").val('1');
        $("#unique_identifier_label_exist").val(checkUniqueIdentifier);

        const input = document.querySelector("#label_phone_number");
        if (input) {
          input.style.paddingLeft = "55px";
          phone = intlTelInput(input, {
            initialCountry: "se",
            formatOnDisplay: true,
            useFullscreenPopup: false,
            autoPlaceholder: "polite",
            preferredCountries: ["se", "pl"],
            autoInsertDialCode: true,
            separateDialCode: false,
            onlyCountries: ["al", "at", "by", "be", "ba", "bg", "hr", "cz", "dk",
              "ee", "fi", "fr", "de", "gi", "gr", "hu", "ie", "it", "lv",
              "lt", "mk", "mt", "md", "me", "nl", "no", "pl", "pt", "ro",
              "ru", "rs", "sk", "si", "es", "se", "ch", "ua", "gb","tr"],
            nationalMode: false,
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/18.2.1/js/utils.min.js"
          });
          
          // Format the phone number in E164 format on initialization if it has a value
          if (input.value && window.intlTelInputUtils) {
            setTimeout(() => {
              if (phone && phone.isValidNumber()) {
                input.value = phone.getNumber(intlTelInputUtils.numberFormat.E164);
              }
            }, 100);
          }
          
          // Add event listener for phone number changes
          input.addEventListener('blur', function() {
            if (phone && window.intlTelInputUtils && phone.isValidNumber()) {
              this.value = phone.getNumber(intlTelInputUtils.numberFormat.E164);
            }
          });
        }

      }
    // }
  }

  _initiateVirtualKeyboard() {
    //TODO: Why do we need to remove this class again from virtualKeyboardSlotTimeBooking?
    $("#virtualKeyboardOTP").removeClass("simple-keyboard");
    $("#virtualKeyboardSlotTimeBooking").removeClass("simple-keyboard");
    $("#virtualKeyboardForm").addClass("simple-keyboard");
    function onDocumentClick(event) {
      // Get the active element
      const activeElement = document.activeElement;
      if (event.target.classList.contains('form-control')) {
        // If the clicked target is a different form control, focus it
        if (activeElement !== event.target) {
          event.target.focus();  // Manually focus the target
        }
        return; // Exit from the function early as there's no need to process other conditions
      }

      // Check if the clicked target is not a form control and not part of the simple-keyboard
      if (!event.target.classList.contains('form-control') && !$(event.target).closest(".simple-keyboard").length) {
        // If the active element is a form control, then blur it to hide keyboard
        if (activeElement && activeElement.classList.contains('form-control')) {
          activeElement.blur();
        }
      }
    }


    if (localStorage.getItem('virtualKeyboard') === 'true') {
      let firstInput = document.querySelector('#form_field_name');
      if (firstInput) {
        firstInput.focus();
        selectedInput = `#${firstInput.id}`; // Assigning the variable defined at a higher scope
      }
      $(document).on('click touchstart', onDocumentClick);
      $('body').addClass('virtual-keyboard-active');


      const defaultTheme = "hg-theme-default";


      $(document).on('focus', '.form-control', function () {
        $(".simple-keyboard").show();
      });

      $(document).on('touchstart', '.form-control', function () {
        $(".simple-keyboard").show();
      });

      $(document).on('blur', '.form-control', function () {
        $(".simple-keyboard").hide();
      });

      if (keyboardInstance) {
        keyboardInstance.destroy(); // Replace with the actual method to destroy the keyboard if it exists
      }


      keyboardInstance = new Keyboard({
        onChange: input => onChange(input),
        theme: defaultTheme,
        layout: {
          'default': [
            '1 2 3 4 5 6 7 8 9 0 {bksp}',
            'Q W E R T Y U I O P Å',
            'A S D F G H J K L Ä Ö',
            'Z X C V B N M . - @',
            '{space}'
          ],
          'numeric': [
            '1 2 3',
            '4 5 6',
            '7 8 9',
            '+ 0 {bksp}'
          ]
        },
        display: {
        '{bksp}': '⌫',
          '{space}': ' '
      }
      });

      const form = document.getElementById("formfieldlabelform");
      // Check if the form exists to avoid potential null errors
      if (form) {
        // Select all form-control elements within the specified form
        form.querySelectorAll(".form-control").forEach(input => {
          input.addEventListener("focus", onInputFocus);
          input.addEventListener("touchstart", onInputFocus); // Add this line
          input.addEventListener("input", onInputChange);
        });
      } else {
        console.warn("Form with ID 'formfieldlabelform' not found.");
      }

      function onInputFocus(event) {
        selectedInput = `#${event.target.id}`;
        const inputValue = document.querySelector(selectedInput).value;
        keyboardInstance.setInput(inputValue, event.target.id);

        if (event.target.id === "label_phone_number") {
          keyboardInstance.setOptions({
            layoutName: "numeric",
            inputName: event.target.id
          });
        } else {
          keyboardInstance.setOptions({
            layoutName: "default",
            inputName: event.target.id
          });
        }
      }

      function onInputChange(event) {
        keyboardInstance.setInput(event.target.value, event.target.id);
      }

      function onChange(input) {
        const inputElem = document.querySelector(selectedInput || ".input");
        inputElem.value = input;
        inputElem.dispatchEvent(new Event('input'));
      }

    }
    $('#form_field_name').focus();
  }

  _initiateAutoPopulate() {
    function autoco(inp, arr, inputid) {
      /*the autocomplete function takes two arguments,
      the text field element and an array of possible autocompleted values:*/
      var currentFocus;
      /*execute a function when someone writes in the text field:*/
      inp.addEventListener("input", function (e) {
        var a, b, i, val = this.value;
        /*close any already open lists of autocompleted values*/
        closeAllLists();
        if (!val) { return false; }
        currentFocus = -1;
        /*create a DIV element that will contain the items (values):*/
        a = document.createElement("DIV");
        a.setAttribute("id", this.id + "autocomplete-list");
        a.setAttribute("class", "autocomplete-items");
        /*append the DIV element as a child of the autocomplete container:*/
        this.parentNode.appendChild(a);
        /*for each item in the array...*/
        let count = 0;  // Initialize the counter
        for (i = 0; i < arr.length; i++) {
          /*check if the item contains the text field value:*/
          if (arr[i].toUpperCase().indexOf(val.toUpperCase()) >= 0) {
            /*create a DIV element for each matching element:*/
            b = document.createElement("DIV");
            /*highlight the matching substring:*/
            var startPos = arr[i].toUpperCase().indexOf(val.toUpperCase());
            var endPos = startPos + val.length;
            b.innerHTML = arr[i].substr(0, startPos) + "<strong>" + arr[i].substr(startPos, val.length) + "</strong>" + arr[i].substr(endPos);
            /*insert an input field that will hold the current array item's value:*/
            b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
            /*execute a function when someone clicks on the item value (DIV element):*/
            b.addEventListener("click", function (e) {
              /*insert the value for the autocomplete text field:*/
              var selectval = this.getElementsByTagName("input")[0].value;
              $("#" + inputid).val(selectval);
              $("#" + inputid).trigger('click');
              /*close the list of autocompleted values, (or any other open lists of autocompleted values:*/
              closeAllLists();
            });
            a.appendChild(b);
            count++;  // Increment the counter
            if (count >= 6) break;  // Break the loop if count reaches 6
          }
        }
      });
      /*execute a function presses a key on the keyboard:*/
      inp.addEventListener("keydown", function (e) {
        var x = document.getElementById(this.id + "autocomplete-list");
        if (x) x = x.getElementsByTagName("div");
        if (e.keyCode === 40) {
          /*If the arrow DOWN key is pressed,
          increase the currentFocus variable:*/
          currentFocus++;
          /*and and make the current item more visible:*/
          addActive(x);
        } else if (e.keyCode === 38) { //up
          /*If the arrow UP key is pressed,
          decrease the currentFocus variable:*/
          currentFocus--;
          /*and and make the current item more visible:*/
          addActive(x);
        } else if (e.keyCode === 13) {
          /*If the ENTER key is pressed, prevent the form from being submitted,*/
          e.preventDefault();
          if (currentFocus > -1) {
            /*and simulate a click on the "active" item:*/
            if (x) x[currentFocus].click();
          }
        } else if (e.keyCode === 9) {
          // Prevent default behaviour of tab if needed e.g. moving to next focusable element
          // e.preventDefault();

          // Close all autocomplete lists
          closeAllLists();
        }
      });
      function addActive(x) {
        /*a function to classify an item as "active":*/
        if (!x) return false;
        /*start by removing the "active" class on all items:*/
        removeActive(x);
        if (currentFocus >= x.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = (x.length - 1);
        /*add class "autocomplete-active":*/
        x[currentFocus].classList.add("autocomplete-active");
      }
      function removeActive(x) {
        /*a function to remove the "active" class from all autocomplete items:*/
        for (var i = 0; i < x.length; i++) {
          x[i].classList.remove("autocomplete-active");
        }
      }
      function closeAllLists(elmnt) {
        if ($(elmnt).closest(".simple-keyboard").length || $(elmnt).closest(".autocomplete-items").length) {
          return; // Do not close the lists
        }
        var x = document.getElementsByClassName("autocomplete-items");
        for (var i = 0; i < x.length; i++) {
          x[i].parentNode.removeChild(x[i]);
        }
      }

      document.addEventListener("click", function (e) {
        closeAllLists(e.target);
      });
    }

    document.querySelectorAll('.autocmp').forEach(element => {
      element.addEventListener('focus', function () {
        const inputId = this.id;
        const autoCmpArray = this.getAttribute('data-autoarr').split(',');
        autoco(document.getElementById(inputId), autoCmpArray, inputId);
        this.setAttribute('data-valid-options', JSON.stringify(autoCmpArray));
      });

    });
    this._initiateWhoVisitAutocomplete();
  }

  _initiateWhoVisitAutocomplete() {
    const whoVisitInput = document.getElementById("label_who_visit");
    if (!whoVisitInput) return;
    const locationId = this._slideshow._location.id;

    let requiresExactMatch = false;
    let validOptions = {};
    let originalValue = '';

    function closeAllLists(elmnt) {
      const x = document.getElementsByClassName("autocomplete-items");
      for (let i = 0; i < x.length; i++) {
        if (elmnt !== x[i] && elmnt !== whoVisitInput) {
          x[i].parentNode.removeChild(x[i]);
        }
      }
    }

    whoVisitInput.addEventListener("input", function () {
      const val = this.value;
      closeAllLists();
      if (!val) return false;

      $.post("/contacts/search", { query: val, location_id: locationId }, function (response) {
        const data = response.contacts || [];
        requiresExactMatch = response.requiresExactMatch;

        if (!data.length) return;

        validOptions = {}; // reset valid options

        const a = document.createElement("DIV");
        a.setAttribute("id", whoVisitInput.id + "autocomplete-list");
        a.setAttribute("class", "autocomplete-items");
        whoVisitInput.parentNode.appendChild(a);

        data.forEach(contact => {
          validOptions[contact.id] = contact.name; // store valid name
          const b = document.createElement("DIV");
          b.innerHTML = "<strong>" + contact.name.substr(0, val.length) + "</strong>" + contact.name.substr(val.length);
          b.innerHTML += "<input type='hidden' value='" + contact.name + "' data-contact-id='" + contact.id + "'>";

          function handleContactSelection() {
            const contactId = this.getElementsByTagName("input")[0].dataset.contactId;
            const selectedValue = this.getElementsByTagName("input")[0].value;

            localStorage.setItem("contact_to_visit", contactId || null);
            whoVisitInput.value = selectedValue;
            originalValue = selectedValue;
            closeAllLists();
          }

          // Add event listeners using the same handler
          b.addEventListener("click", handleContactSelection);
          b.addEventListener("touchstart", handleContactSelection);

          a.appendChild(b);
        });
      });
    });

    // Prevent invalid value on blur
    whoVisitInput.addEventListener("blur", function () {
      if (isValidating) return false; // Prevent multiple validations

      // Check if the field is required before setting isValidating flag
      const isRequired = whoVisitInput.hasAttribute("required");
      if (!isRequired) return; // Don't validate if not required

      isValidating = true;
      setTimeout(function () {
        const currentValue = whoVisitInput.value;

        const isValid = Object.values(validOptions).some(name => name.toLowerCase() === currentValue.toLowerCase());
        if (!isValid && currentValue !== '' && requiresExactMatch) {
          new Modal({
            titleText: lang.get('form_required'),
            bodyText: lang.get('select_person_from_list'),
            submitBtnText: lang.get('form_modal_button'),
            onHidden: () => {
              isValidating = false; // Reset the flag when modal closes
              document.getElementById("label_who_visit").focus();
              document.getElementById("label_who_visit").value='';
            }
          });
        } else if (isValid) {
          originalValue = currentValue;
          const foundEntry = Object.entries(validOptions).find(
            ([key, value]) => value.toLowerCase() === currentValue.toLowerCase()
          );
          if (foundEntry) {
            const [id, name] = foundEntry;
            localStorage.setItem("contact_to_visit", id || null);
          }
          isValidating = false; // Reset the flag when modal closes
        } else {
          isValidating = false; // Reset the flag when modal closes
        }
      }, 200);
    });


    document.addEventListener("click", function (e) {
      closeAllLists(e.target);
    });

    // Store validator
    this._whoVisitValidator = () => {
      if (!requiresExactMatch) return true;
      const currentValue = whoVisitInput.value;
      return Object.values(validOptions).some(name => name.toLowerCase() === currentValue.toLowerCase()) || currentValue === '';
    };
  }


  _removeVirtualKeyboard() {
    if (keyboardInstance !== undefined) keyboardInstance.destroy();
    keyboardInstance = undefined;
    $("#virtualKeyboardForm").removeClass("simple-keyboard");
  }

  _restoreValidation() {
    isValidating = false;
  }

  getstatusofIdScanApproval(idscanID) {

    var intervalvar = setInterval(function() {
      $.ajax({
        method: 'POST',
        url: 'slideshow/check-approval-idscan',
        data: { "idscanID": idscanID },
        async: false,
        success: (res) => {
         if (res != '') {
          if(res[0]['is_scan_approve']  == 1) {
            $('#modal').modal('hide');
            $(".modal-backdrop").remove();
            $( "body" ).css( "pointer-events", "visible" );
            localStorage.removeItem("idscan_approve_status");
            localStorage.removeItem("idscan_id");
          }
          if(res[0]['is_scan_approve']  == 2) {
            $('#modal').modal('hide');
            $(".modal-backdrop").remove();
            clearInterval(intervalvar);

            new Modal({
              titleText: lang.get('queue_wait'),
              bodyText: lang.get('idscan_disapprove'),
            });
            $(".close").hide();
            $("#modal-submit-button").hide();
            $( "body" ).css( "pointer-events", "none" );
            localStorage.removeItem("idscan_approve_status");
            localStorage.removeItem("idscan_id");
            let countdown = 20;
            this._intervalHandler = setInterval(() => {
              countdown -= 1;

              if (countdown === 0) {
                $( "body" ).css( "pointer-events", "visible" );
                $('#modal').modal('hide');
                $(".modal-backdrop").remove();
                localStorage.removeItem("idscan_approve_status");
                window.location.hash = '/';
               clearInterval(this._intervalHandler);
              }
            }, 1000);
          }
         }
        }
      });
  }, 5000);
  }

};
setInterval(function() {}, 5000);